import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-185">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="dialog" aria-modal="true" aria-label={title} data-id="element-186">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-187" />

          {/* Panel */}
          <motion.div className="relative z-10 w-full max-w-2xl max-h-[85vh] flex flex-col glass-panel rounded-3xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} data-id="element-188">
            <div className="absolute top-0 left-0 right-0 h-1 bg-chakra-gradient opacity-50" data-id="element-189" />

            <div className="flex items-center justify-between px-6 sm:px-8 pt-8 pb-4 shrink-0" data-id="element-190">
              <h2 className="text-2xl sm:text-3xl font-bold text-white pr-8" data-id="element-191">
                {title}
              </h2>
              <button onClick={onClose} className="shrink-0 p-2 rounded-full text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50" aria-label="Cerrar" data-id="element-192">
                <X className="w-5 h-5" data-id="element-193" />
              </button>
            </div>

            <div className="px-6 sm:px-8 pb-8 overflow-y-auto text-zinc-400 leading-relaxed space-y-4" data-id="element-194">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}